export default class Constants { }

Constants.continue = 'continue';
Constants.cordSide = 'cordSide';
Constants.fabric = 'fabric';
Constants.frameColor = 'frameColor';
Constants.model = 'model';
Constants.mount = 'mount';
Constants.projection = 'projection';
Constants.proUpgrade = 'proUpgrade';
Constants.proFsColor = 'fsColor';
Constants.led = 'led';
Constants.series = 'series';
Constants.valanceStyle = 'valanceStyle';
Constants.sunsetterLaminated = 'SunSetter Laminated';
Constants.waveValance = 'Wave Valance';
